import React, {Dispatch, SetStateAction, useContext, useState} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import LayoutContext from "../../context/LayoutContext"
import {ModalContext} from "../../context/ModalContext"
import {ArrowRight, ChevronDown} from "react-bootstrap-icons"
import Button from "../reusable/components/Button"
import DataContext from "../../context/DataContext"
import HpCategoryStyles from "./HpCategoryStyles"
import useCache from "../../hooks/useCache"
import {useRouter} from "next/router"
import {filterUrl} from "../filter/FilterUrl"
import InputWithLabelAndIcon from "../reusable/InputWithLabelAndIcon"

type Props = {
	setAutoplayCarousel:Dispatch<SetStateAction<boolean>>
}
function HomepageHeightCta({setAutoplayCarousel}:Props) {
	const {t} = useTranslation()
	const [height, setHeight] = useState<string>("")
	const [errors, setErrors] = useState<any>({})
	const {isMobile} = useContext(LayoutContext)
	const router = useRouter()
	const {setModalContent, openDrawer, setIsMobile, setHasShadow} = useContext(ModalContext)
	const {pageProps, activeHpLifestyleCategories: activeCategories} = useContext(DataContext)
	const categories = pageProps?.strapiContent?.data?.mega_menus?.filter(item => ["e_bike", "bike"].includes(item?.attributes?.slugName)).reduce((acc, newVal) => {
		acc = [...acc, ...(newVal?.attributes?.topCategories || [])]
		return acc
	}, [])

	const handleOpen = e => {
		e.stopPropagation()
		setErrors({})
		setModalContent(() => (
			<HpCategoryStyles
				isMobile={isMobile}
				categories={categories}

			/>
		))
		setHasShadow(() => false)
		setIsMobile(() => isMobile)
		setAutoplayCarousel(false)
		openDrawer()
	}

	const handleSubmit = e => {
		const url = filterUrl({categories: activeCategories?.map(idx => categories?.[idx]?.slugName)?.join(","), body_height: `${height}-bis-${height}`}, null, null)
		if (activeCategories.includes(123)) {
			router.push("/suggestion-quiz")
		} else if (activeCategories?.length && height) {
			router.push(url)
		}

		setErrors({height: !height?.length, category: !activeCategories?.length})
	}

	const displayLable = () => {
		if (activeCategories.includes(123)) {
			return t("start-the-quiz")
		}

		return t("find-match")
	}

	const {data, isLoading: isLoadingProductsCount} = useCache(`/api/products/product-results-counter?params=${JSON.stringify({categories: activeCategories?.map(idx => categories?.[idx]?.slugName)?.join(","), body_height: `${height}-bis-${height + 5}`})}&locale=${router.locale}`)
	return (
		<div style={{marginTop: "20px", gap: "12px"}}
			onClick={e => {
				e.stopPropagation()
				setAutoplayCarousel(false)
			}}
			className="d-flex align-items-center justify-content-start flex-md-row flex-column">
			<div className="d-flex align-items-start gap-3 justify-content-start">
				<InputWithLabelAndIcon inputValue={height}
					errors={errors}
					setErrors={setErrors}
					label={t("whats-your-height")}
					inputName="height"
					setInputValue={setHeight}
					icon={<Typography style={{height: "20px", fontSize: "14px", lineHeight: "20px", color: "#000"}}
						variant="bodySm">cm</Typography>} />
				<div onClick={handleOpen}
					style={{gap: "4px"}}
					className={`d-flex cursor-pointer align-items-start justify-content-start flex-column ${errors?.category ? "text-danger" : ""}`}>
					<Typography style={{height: "20px", fontSize: "14px", lineHeight: "20px"}}
						variant="bodyLg">{t("whats-your-lifestyle")}</Typography>
					<div className={`height-cta-field ${errors?.category ? "danger" : ""} `}>
						<Typography variant="bodySm"
							className="text-black"
							style={{minWidth: isMobile ? "128px" : "148px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{ activeCategories?.filter(item => item !== 123)?.length ? activeCategories?.map(idx => categories?.[idx]?.title)?.join(", ") : activeCategories?.includes(123) ? t("idk-where-to-start-label") : t("select-one")}</Typography>
						<ChevronDown style={{width: "24px"}}
							color="#212529"
							size={15} />
					</div>
				</div>
			</div>
			<Button bgColor="#FEC04D"
				btnFontSize={14}
				paddingY="null"
				color="#000"
				isLoading={isLoadingProductsCount}
				onClick={handleSubmit}
				style={{paddingTop: "9px", paddingBottom: "9px"}}
				className="m-0 align-self-end col-12 col-md-auto"
				icon={<ArrowRight size={20} />}

			>
				<Typography variant="bodyLgBold"
					style={{fontSize: "14px", lineHeight: "20px"}}>{data?.totalNumberOfProducts && activeCategories?.filter(item => item !== 123)?.length ? `${data?.totalNumberOfProducts} ${t("bikes-found")}` : displayLable()}</Typography>
			</Button>
		</div>
	)
}

export default HomepageHeightCta
